import React from 'react';
import { bool, shape, string } from 'prop-types';

const ChevronRight = ({
  className = 'icon',
  notUseClass = false,
  style = { color: '#696f88' },
}) => (
  <svg className={notUseClass ? '' : className} style={style} width="1em" height="1em" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.70498 6L8.29498 7.41L12.875 12L8.29498 16.59L9.70498 18L15.705 12L9.70498 6Z" fill="currentColor" />
  </svg>
);

ChevronRight.propTypes = {
  className: string,
  notUseClass: bool,
  style: shape({}),
};

export default ChevronRight;
